import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { SERVICES_OVERVIEW, PAGE_BANNERS } from "../data/content";

export default function ServicesOverview() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.services} alt="Services" fallbackKey="services" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>{SERVICES_OVERVIEW.title}</h1>
          <p className="nn-italic-tagline -mt-2 mb-6">{SERVICES_OVERVIEW.subtitle}</p>
          <p>{SERVICES_OVERVIEW.body}</p>
        </article>
      </div>
    </div>
  );
}
